import { styled } from '@mui/material';

export const HBLoadingRootStyle = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
}));

export const HBLoadingCircleStyle = styled('span')(({ theme }) => {
  return {
    borderRadius: '50%',
    width: theme.spacing(2),
    height: theme.spacing(2),
    background: theme.palette.primary.main,
  };
});
